var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"display":"flex","justify-content":"space-between"}},[_c('div',{staticStyle:{"font-weight":"bold"}},[_vm._v(" "+_vm._s(_vm.product.code)+" ")]),_c('div',[_vm._v(" x "+_vm._s(_vm.product.amount)+" ")])]),_c('div',[_vm._v(" "+_vm._s(_vm.product.size)+" "+_vm._s(_vm.product.color)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }